// @flow

import { makeApiCall } from '../../../../../services/apiService/apiService';

export const createPrqActions = {
  CHECK_PINCODE_SERVICEABILITY: 'CHECK_PINCODE_SERVICEABILITY',
  CREATE_PRQ: 'CREATE_PRQ',
  GET_TIME_SLOTS: 'GET_TIME_SLOTS',
  GET_SUGGESTED_CAPTAINS: 'GET_SUGGESTED_CAPTAINS',
  CREATE_PICKUP: 'CREATE_PICKUP',
  GET_EXISTING_PICKUPS: 'GET_EXISTING_PICKUPS',
  GET_PICKUP_DATA: 'GET_PICKUP_DATA',
  PRQ_ANALYTICS: 'PRQ_ANALYTICS',
  GET_PICKUP_CONFIG: 'GET_PICKUP_CONFIG',
  GET_RECENT_PICKUPS: 'GET_RECENT_PICKUPS'
};

export const createPickupCallAction = (load: Object) => ({
  type: createPrqActions.CREATE_PICKUP,
  payload: load
});

export const getSuggestedCaptainsAction = (load: Object) => ({
  type: createPrqActions.GET_SUGGESTED_CAPTAINS,
  payload: load
});

export const getTimeSlotsAction = (load: Object) => ({
  type: createPrqActions.GET_TIME_SLOTS,
  payload: load
});

export const getExistingPickupsDateWiseAction = (load: Object) => ({
  type: createPrqActions.GET_EXISTING_PICKUPS,
  payload: load
});

export const getPickupDataAction = (load: Object) => ({
  type: createPrqActions.GET_PICKUP_DATA,
  payload: load
});

export const prqAnalyticsAction = (load: Object) => ({
  type: createPrqActions.PRQ_ANALYTICS,
  payload: { analyticsdata: load }
});

export const getRecentPickupsAction = payload => ({
  type: createPrqActions.GET_RECENT_PICKUPS,
  payload
});

export const createPickupCall = (obj: Object, callback = false) => (
  dispatch: Function
) => {
  const createUpdateStr = obj.id ? 'Update' : 'Create';
  dispatch(
    createPickupCallAction({
      postCallInitiated: true,
      postCallCompleted: false,
      postCallFailureMsg: null,
      warning: null,
      analyticsdata: {
        event_category: 'createprqv2',
        event_action: `Initiate ${createUpdateStr} PRQ`,
        event_label: `User ID ${obj.loggedInUserId}`
      }
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pickup',
    method: 'POST',
    data: obj,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (res.payload && res.payload.timeSlotValidationPassed === false) {
          dispatch(
            createPickupCallAction({
              postCallInitiated: false,
              postCallCompleted: true,
              postCallFailureMsg: res.errorMessage,
              postCallData: null,
              warning: true,
              analyticsdata: {
                event_category: 'createprqv2',
                event_action: `${createUpdateStr} PRQ Timeslot validation failed`,
                event_label: `User ID ${obj.loggedInUserId}`
              }
            })
          );
        } else {
          dispatch(
            createPickupCallAction({
              postCallInitiated: false,
              postCallCompleted: true,
              postCallFailureMsg: null,
              postCallData: res.payload,
              warning: null,
              analyticsdata: {
                event_category: 'createprqv2',
                event_action: `${createUpdateStr} PRQ Success`,
                event_label: `User ID ${obj.loggedInUserId}`
              }
            })
          );
          if (callback) {
            callback();
          }
        }
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to get createPickupCall ', res);
        dispatch(
          createPickupCallAction({
            postCallInitiated: false,
            postCallCompleted: true,
            postCallData: null,
            postCallFailureMsg:
              res.errorMessage ||
              `Could not ${createUpdateStr &&
                createUpdateStr.toLowercase()} pickup`,
            warning: null,
            analyticsdata: {
              event_category: 'createprqv2',
              event_action: `${createUpdateStr} PRQ call failure`,
              event_label: `User ID ${obj.loggedInUserId}`
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to get createPickupCall ', res);
      dispatch(
        createPickupCallAction({
          postCallInitiated: false,
          postCallCompleted: true,
          postCallData: null,
          postCallFailureMsg:
            res.errorMessage ||
            `Could not ${createUpdateStr &&
              createUpdateStr.toLowercase()} pickup`,
          warning: null,
          analyticsdata: {
            event_category: 'createprqv2',
            event_action: `${createUpdateStr} PRQ call failure`,
            event_label: `User ID ${obj.loggedInUserId}`
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getting createPickupCall ', res);
      dispatch(
        createPickupCallAction({
          postCallInitiated: false,
          postCallCompleted: true,
          postCallData: null,
          postCallFailureMsg: `Could not ${createUpdateStr &&
            createUpdateStr.toLowercase()} pickup`,
          analyticsdata: {
            event_category: 'createprqv2',
            event_action: `${createUpdateStr} PRQ call exception`,
            event_label: `User ID ${obj.loggedInUserId}`
          }
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const getSuggestedCaptains = (obj: Object) => (dispatch: Function) => {
  dispatch(
    getSuggestedCaptainsAction({
      captainList: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: obj.pickupId ? 'pickupuser' : 'getSuggestedCaptains',
    method: obj.pickupId ? 'GET' : 'POST',
    replaceParamsArr: [{ key: 'pickupId', val: obj.pickupId }],
    data: !obj.pickupId
      ? {
          clientId: obj.clientId,
          clientAddressDTO: obj.clientAddressDTO,
          pickupTimeSlot: obj.pickupTimeSlot,
          pickupDate: obj.pickupDate,
          uuid: obj.uuid,
          pickupId: obj.pickupId
        }
      : null,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getSuggestedCaptainsAction({
            captainList: obj.pickupId ? res.payload : res.payload.captainList,
            suggestedCaptainId: obj.pickupId
              ? null
              : res.payload.suggestedCaptainId,
            suggestedBPId: obj.pickupId ? null : res.payload.suggestedBPId,
            selectedCaptainId: obj.pickupId
              ? null
              : res.payload.suggestedCaptainId,
            uuid: obj.pickupId ? null : res.payload.uuid,
            message: obj.pickupId ? null : res.payload.message
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to get getSuggestedCaptains ', res);
        dispatch(
          getSuggestedCaptainsAction({
            captainList: [],
            suggestedCaptainId: null,
            selectedCaptainId: null,
            suggestedBPId: null,
            message: null,
            uuid: null,
            errorMessage: res.errorMessage
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to get getSuggestedCaptains ', res);
      dispatch(
        getSuggestedCaptainsAction({
          captainList: [],
          suggestedCaptainId: null,
          suggestedBPId: null,
          selectedCaptainId: null,
          uuid: null,
          errorMessage:
            res.errorMessage || 'Could not fetch captain list for assignment'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getting getSuggestedCaptains ', res);
      dispatch(
        getSuggestedCaptainsAction({
          captainList: [],
          suggestedCaptainId: null,
          suggestedBPId: null,
          uuid: null,
          selectedCaptainId: null,
          errorMessage: 'Could not fetch captain list for assignment'
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const getTimeSlots = (pickupDateTimeStamp: number) => (
  dispatch: Function
) => {
  dispatch(
    getTimeSlotsAction({
      timeSlotList: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getTimeSlots',
    replaceParamsArr: [{ key: 'pickupdate', val: pickupDateTimeStamp }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getTimeSlotsAction({
            timeSlotList: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to get timeslots ', res);
        dispatch(
          getTimeSlotsAction({
            timeSlotList: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to get timeslots ', res);
      dispatch(
        getTimeSlotsAction({
          timeSlotList: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getting timeslots ', res);
      dispatch(
        getTimeSlotsAction({
          timeSlotList: []
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const getExistingPickupsDateWise = (obj: number) => (
  dispatch: Function
) => {
  dispatch(
    getExistingPickupsDateWiseAction({
      existingPickupsFetching: true,
      existingPickups: null
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'existingPickups',
    replaceParamsArr: [
      { key: 'clientId', val: obj.clientId },
      { key: 'clientAddressId', val: obj.clientAddressId },
      { key: 'pickupDate', val: obj.pickupDate }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getExistingPickupsDateWiseAction({
            existingPickupsFetching: false,
            existingPickups: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure in getExistingPickupsDateWise ', res);
        dispatch(
          getExistingPickupsDateWiseAction({
            existingPickupsFetching: false,
            existingPickups: []
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure in getExistingPickupsDateWise ', res);
      dispatch(
        getExistingPickupsDateWiseAction({
          existingPickupsFetching: false,
          existingPickups: []
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getting existing pickups ', res);
      dispatch(
        getExistingPickupsDateWiseAction({
          existingPickupsFetching: false,
          existingPickups: []
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const getPickupData = (pickupId: string) => (dispatch: Function) => {
  dispatch(
    getPickupDataAction({
      fetchingPickupData: true,
      fetchedPickupData: false,
      pickupData: null,
      pickupFetchError: null
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getpickup',
    pathVariables: [{ key: '{id}', val: pickupId }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getPickupDataAction({
            fetchingPickupData: false,
            fetchedPickupData: true,
            pickupData: res.payload,
            pickupFetchError: null
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getPickupDataAction ', res);
        dispatch(
          getPickupDataAction({
            fetchingPickupData: false,
            fetchedPickupData: true,
            pickupData: null,
            pickupFetchError: res.errorMessage || 'Failed to fetch pickup data'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getPickupDataAction ', res);
      dispatch(
        getPickupDataAction({
          fetchingPickupData: false,
          fetchedPickupData: true,
          pickupData: null,
          pickupFetchError: res.errorMessage || 'Failed to fetch pickup data'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getPickupDataAction ', res);
      dispatch(
        getPickupDataAction({
          fetchingPickupData: false,
          fetchedPickupData: true,
          pickupData: null,
          pickupFetchError: 'Failed to fetch pickup data'
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const prqAnalytics = (analyticsdata: Object) => dispatch => {
  dispatch(prqAnalyticsAction(analyticsdata));
};

/**
 * getRecentPickups: Get recent pickup details from backend
 *
 * @returns makeApiCall()
 */
export const getRecentPickups = () => dispatch => {
  dispatch(
    getRecentPickupsAction({
      recentPickupsList: []
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getRecentPickups',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getRecentPickupsAction({
            recentPickupsList: res.payload || []
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getRecentPickupsAction({
            recentPickupsList: []
          })
        );
      } else {
        // mandatory else condition (currently empty)
      }
    },
    failureCb: () => {
      dispatch(
        getRecentPickupsAction({
          recentPickupsList: []
        })
      );
    },
    catchCb: () => {
      dispatch(getRecentPickupsAction({}));
    }
  };
  return makeApiCall(requestObj);
};
